import { render } from "./Games.vue?vue&type=template&id=fc012cca&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"

import "./Games.vue?vue&type=style&index=0&id=fc012cca&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1672060877/src/vivamo-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc012cca"]])

export default __exports__